import { Validator } from "./use-validation";

export const onlyDigits: Validator = {
  errorMessage: "Only digits allowed",
  callback: (value) => /^\d*$/.test(value),
};
